class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.setHeaderCartIconAccessibility();
    this.addEventListener('keyup', function(event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close.bind(this)(event);
      }
    }.bind(this), false);

    // Intercept close-button clicks in capture phase to ensure CartDrawer.close() is called
    this.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('close-button');
      if (closeBtn && this.contains(closeBtn)) {
        e.stopPropagation();
        e.preventDefault();
        this.close();
      }
    }, true);
  }

  setHeaderCartIconAccessibility() {
    const _this = this;
    const cartLink = document.querySelector('#cart-icon-bubble') || document.querySelector('#cart-icon-bubble-mobile');
    const cartAction = document.querySelectorAll('.icon--cart-action');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    if (cartAction.length != 0) {
      cartAction.forEach(e => {
        e.addEventListener('click', (event) => {
          event.preventDefault();
          _this.open(e);
        });
      });
    }
  }


  open(triggeredBy) {
    closePopup.hide();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      trapFocus(document.querySelector("cart-drawer"));
    }, 500);
    setTimeout(() => {this.classList.add('active');});
    root.classList.add('open-canvas');
    rootAction.addNoneHeight();

    const cartRecommend = document.querySelector(".cart-upsell-js.cart-type-select");
    if (cartRecommend) {
      const productRecommend = cartRecommend.querySelector('.slide-container');
      if (productRecommend.childElementCount === 0) {
        document.querySelector('.drawer__inner').classList.add('hidden-cart-upsell')
      }
    }
  }

  close() {
    removeTrapFocus(this.activeElement);
    rootAction.remove();
    this.classList.remove('active');
    // Remove Boost Commerce cart modal class that blocks body scroll
    document.body.classList.remove('modal-open-cart');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach(((section, index) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      const cartDrawer = this.getSectionDOM(parsedState.sections[section.id], section.selector);
      const cartRecommend = cartDrawer.querySelector(".cart-upsell-js.cart-type-select");
      if (cartRecommend) {
        const productRecommend = cartRecommend.querySelector('.slide-container');
        if (productRecommend.childElementCount == 0) {
          document.querySelector('.drawer__inner').classList.add('hidden-cart-upsell')
        }
      }
      if (index === 1) {
        const mobile_nav_bar_id = document.querySelector("#cart-icon-bubble-mobile");
        if (mobile_nav_bar_id && mobile_nav_bar_id.querySelector(".cart-count") && sectionElement.querySelector(".cart-count")) {
          mobile_nav_bar_id.querySelector(".cart-count").innerHTML = sectionElement.querySelector(".cart-count").innerHTML;
        }
      }
    }));
    
    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartNoteElement extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init(){
    this.toggleCartNote();
  }
  toggleCartNote(){
    const title = this.querySelector(".cart-note-title-js");
    if (!title) return;
    title.addEventListener("click", this.onToggle.bind(this), false);
    this.addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        this.onToggle.bind(this)(event);
      }
    }.bind(this), false);
  }
  onToggle(e){
    const _this = this;
    e.preventDefault();
    if (!_this.querySelector(".cart-note-content")) return;
    slideAnime({
      target: _this.querySelector(".cart-note-content"),
      animeType: "slideToggle",
    });
  }
}
customElements.define('cart-note-element', CartNoteElement);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class MinicartUpsell extends HTMLElement {
  constructor() {
    super();
  }
  init(){
    this.connectedCallback();
  }
  connectedCallback() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.slide-container');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.querySelector(".slide-container").innerHTML = recommendations.innerHTML;
        }
      })
      .finally(() =>{
        setTimeout(() => {
          if(this.querySelector("slide-section")) {
            this.querySelector("slide-section").initSlide(); 
          }
        }, 100);
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('minicart-recommendations', MinicartUpsell);
// Harbour2nd: compact cart drawer, saved notes and optional colour-matched Hector.
(() => {
  const baseRender = CartDrawer.prototype.renderContents;
  const baseOpen = CartDrawer.prototype.open;
  const baseQuantity = CartDrawerItems.prototype.updateQuantity;
  const rootURL = () => window.Shopify?.routes?.root || '/';
  const settings = drawer => drawer.querySelector('#CartDrawer')?.dataset || {};
  const note = drawer => drawer.querySelector('#H2DrawerNote');
  const message = (drawer, text, error = false) => {
    const target = drawer.querySelector(error ? '.h2-drawer-error' : '.h2-drawer-note-status');
    if (target) { target.textContent = text || ''; target.hidden = !text; }
  };
  async function request(url, body) {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(typeof data.description === 'string' ? data.description : typeof data.errors === 'string' ? data.errors : '');
    return data;
  }
  function capture(drawer) {
    const field = note(drawer);
    if (field && drawer.h2Saved === undefined) drawer.h2Saved = field.defaultValue;
    if (field) drawer.h2Draft = field.value;
  }
  async function saveNote(drawer) {
    capture(drawer);
    while (drawer.h2Draft !== undefined && drawer.h2Draft !== drawer.h2Saved) {
      const value = drawer.h2Draft;
      try {
        await request(rootURL() + 'cart/update.js', { note: value });
        drawer.h2Saved = value;
        capture(drawer);
      } catch (_) {
        message(drawer, settings(drawer).h2NoteError, true);
        throw new Error(settings(drawer).h2NoteError);
      }
    }
  }
  async function run(drawer, action) {
    if (drawer.h2Busy) return;
    drawer.h2Busy = true;
    drawer.setAttribute('aria-busy', 'true');
    const disabled = [...drawer.querySelectorAll('button:not(close-button button), input[name="updates[]"]')].filter(el => !el.disabled);
    disabled.forEach(el => el.disabled = true);
    message(drawer, '', true);
    try { await action(); }
    catch (error) {
      drawer.querySelectorAll('input[name="updates[]"]').forEach(field => { field.value = field.defaultValue; });
      message(drawer, error.message || settings(drawer).h2Error, true);
    }
    finally {
      disabled.forEach(el => { if (el.isConnected) el.disabled = false; });
      drawer.h2Busy = false;
      drawer.removeAttribute('aria-busy');
    }
  }
  async function refresh(drawer, result) {
    let sections = result.sections;
    if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
      const response = await fetch(rootURL() + '?sections=cart-drawer,cart-icon-bubble');
      if (!response.ok) throw new Error(settings(drawer).h2Error);
      sections = await response.json();
    }
    const parser = new DOMParser();
    const replacement = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
    const current = drawer.querySelector('#CartDrawer');
    if (!replacement || !current) throw new Error(settings(drawer).h2Error);
    current.innerHTML = replacement.innerHTML;
    Object.assign(current.dataset, replacement.dataset);
    drawer.classList.toggle('is-empty', !current.querySelector('[data-h2-key]'));
    const badge = document.querySelector('#cart-icon-bubble');
    const badgeNew = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    if (badge && badgeNew) badge.innerHTML = badgeNew.innerHTML;
    const mobileCount = document.querySelector('#cart-icon-bubble-mobile .cart-count');
    if (mobileCount && badge?.querySelector('.cart-count')) mobileCount.innerHTML = badge.querySelector('.cart-count').innerHTML;
    restore(drawer);
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'h2-drawer' });
  }
  function restore(drawer) {
    const field = note(drawer);
    if (!field) return;
    if (drawer.h2Draft !== undefined && drawer.h2Draft !== drawer.h2Saved) field.value = drawer.h2Draft;
    else { drawer.h2Saved = field.value; drawer.h2Draft = field.value; }
  }
  function announce(drawer, id) {
    const target = drawer.querySelector('.h2-drawer-confirmation');
    const row = [...drawer.querySelectorAll('[data-h2-variant]')].find(el => String(el.dataset.h2Variant) === String(id));
    if (target && row) {
      target.textContent = (settings(drawer).h2Added || '[product]').replace('[product]', row.dataset.h2Label);
      target.hidden = false;
    }
  }
  function bind(drawer) {
    if (drawer.h2Bound) return;
    drawer.h2Bound = true;
    capture(drawer);
    drawer.addEventListener('input', event => {
      if (event.target.id === 'H2DrawerNote') { capture(drawer); message(drawer, ''); }
    });
    drawer.addEventListener('click', event => {
      const target = event.target.closest('[data-h2-save-note],[data-h2-add-hector],[data-h2-view-cart],[data-h2-continue]');
      if (!target) return;
      event.preventDefault();
      if (target.hasAttribute('data-h2-continue')) { drawer.close(); return; }
      run(drawer, async () => {
        await saveNote(drawer);
        if (target.hasAttribute('data-h2-save-note')) {
          message(drawer, settings(drawer).h2NoteSaved);
          const label = drawer.querySelector('[data-h2-note-label]');
          if (label) label.textContent = drawer.h2Saved ? settings(drawer).h2NoteEdit : settings(drawer).h2NoteAdd;
          drawer.querySelector('.h2-drawer-note')?.removeAttribute('open');
        } else if (target.hasAttribute('data-h2-view-cart')) {
          window.location.assign(target.href);
        } else {
          const cart = await request(rootURL() + 'cart.js');
          if (cart.items.some(item => item.handle === 'hector')) { await refresh(drawer, {}); return; }
          const id = target.dataset.h2AddHector;
          const result = await request(rootURL() + 'cart/add.js', {
            items: [{ id, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname
          });
          await refresh(drawer, result);
          announce(drawer, id);
        }
      });
    });
    drawer.addEventListener('submit', event => {
      if (event.target.id !== 'CartDrawer-Form') return;
      event.preventDefault();
      run(drawer, async () => {
        await saveNote(drawer);
        // Do not re-submit while the browser is still dispatching the original submit.
        // With an unchanged note there is no network wait, so requestSubmit can be ignored.
        window.location.assign(rootURL() + 'checkout');
      });
    });
  }
  CartDrawer.prototype.open = function(triggeredBy) {
    if (this.classList.contains('h2-modern-drawer')) {
      bind(this);
      restore(this);
      if (triggeredBy) {
        const confirmation = this.querySelector('.h2-drawer-confirmation');
        if (confirmation) confirmation.hidden = true;
      }
    }
    return baseOpen.call(this, triggeredBy);
  };
  CartDrawer.prototype.renderContents = function(result) {
    if (!this.classList.contains('h2-modern-drawer')) return baseRender.call(this, result);
    bind(this);
    capture(this);
    refresh(this, result).then(() => {
      announce(this, result.id || result.items?.[0]?.id);
      this.open();
    }).catch(() => { this.open(); message(this, settings(this).h2Error, true); });
  };
  CartDrawerItems.prototype.updateQuantity = function(line, quantity, name) {
    const drawer = this.closest('cart-drawer');
    if (!drawer?.classList.contains('h2-modern-drawer')) return baseQuantity.call(this, line, quantity, name);
    bind(drawer);
    const row = drawer.querySelector('#CartDrawer-Item-' + line);
    const key = row?.dataset.h2Key;
    if (!key) return;
    run(drawer, async () => {
      await saveNote(drawer);
      const result = await request(rootURL() + 'cart/change.js', {
        id: key, quantity: Number(quantity), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname
      });
      await refresh(drawer, result);
      const updated = result.items?.find(item => item.key === key);
      if (updated && updated.quantity !== Number(quantity)) message(drawer, window.cartStrings?.quantityError?.replace('[quantity]', updated.quantity) || settings(drawer).h2Error, true);
    });
  };
})();
